module.exports = __webpack_public_path__ + "img/chevron-down.193aedd3.svg";